// @flow

import { backendAxios } from './axios-config';
import isEmpty from 'lodash/isEmpty';
import CustomError from '../utils/error';

const { REACT_APP_WB_BACKEND_URL } = process.env;

const getFundsPrices = (policyId: string, period = 1, fundId = 999) => {
  if (isEmpty(REACT_APP_WB_BACKEND_URL)) throw new CustomError('Empty URL');

  return backendAxios.get(`/policies/${policyId}/funds/${fundId}/prices?period=${period}`);
};

export default getFundsPrices;
